import HorizontalStepper from './components/HorizontalStepper';
import { defaultRSIProps } from './hooks/useRsi';
import { SpreadsheetProviders } from './SpreadsheetProviders';
import { RsiProps } from './types';
import Box from 'common/components/box/Box';
import Modal from 'common/components/modal/Modal';

export const ReactSpreadsheetImport = <T extends string>(props: RsiProps<T>) => {

     const customStyles = {
        content: {
            backgroundClip: 'padding-box',
            backgroundColor: '#FFFFFF',
            border: '1px solid transparent',
            borderRadius: '4px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            outline: '0 none',            
            padding: '0',
            minWidth: '85%',
            maxHeight:'95%',
            overflow: 'hidden'
        },
        overlay: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
    };

    return (
        <SpreadsheetProviders rsiValues={{ ...props }}>
            <Modal isOpen={props.isOpen} onRequestClose={props.onClose}  style={customStyles} >
            <Box>
                <HorizontalStepper />
            </Box>
            </Modal>
        </SpreadsheetProviders>
    );

}

ReactSpreadsheetImport.defaultProps = defaultRSIProps
